import type { ChatPlugin } from '#types/plugin/chat'

/**
 * ChatPlugin adapter for Agentforce. Does not load the widget — it only
 * flips the host flags so `<lazy-app-chat-agentforce>` mounts and opens.
 */
export default (): ChatPlugin => {
  const showChat = useState('agentforceShowChat', () => false)
  const isChatOpen = useState('agentforceOpen', () => false)

  return {
    open: () => {
      showChat.value = true
      isChatOpen.value = true
    },
    available: ref(true),
  }
}
